module.exports = __webpack_public_path__ + "static/media/img11.3c1bdcc2.png";